import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { db } from "../../firebase/firebase";
import { collection, doc, getCountFromServer, getDoc, query, Timestamp, where } from "firebase/firestore";
import { QueryKeys } from "config/query-keys";
import { JobInterface } from "./dto";
import { APPLICATION_STATUS } from "enum/job-status-type";

const toCountAsApplicant = [
  APPLICATION_STATUS.APPROVED,
  APPLICATION_STATUS.REJECTED,
  APPLICATION_STATUS.SHORT_LISTED,
  APPLICATION_STATUS.SUBMITTED
]

export const getApplicantCount = async (jobId: string) => {
  const applicationsRef = collection(db, "applications");
  const applicationQuery = query(applicationsRef, where("jobId", "==", jobId),
    where("status", "in", toCountAsApplicant))

  const snapshot = await getCountFromServer(applicationQuery);
  return snapshot.data().count;
};


const getJobDetails = async (id: string | undefined): Promise<JobInterface> => {
  if (!id) {
    throw new Error("Job ID is required");
  }

  try {
    const jobDocRef = doc(db, "jobs", id);
    const jobDoc = await getDoc(jobDocRef);
    const applicantCount = await getApplicantCount(id);

    if (!jobDoc.exists()) {
      throw new Error("Job not found");
    }

    const jobData = jobDoc.data();

    return {
      ...jobData,
      id: jobDoc.id,
      applicant: applicantCount,
      deadlineAt: jobData.deadlineAt instanceof Timestamp
        ? jobData.deadlineAt.toDate()
        : null,
    } as JobInterface;
  } catch (error) {
    console.error("Error fetching job details:", error);
    throw error;
  }
};


export const useGetJobDetails = (id: string | undefined) => {
  const query = useQuery<JobInterface, AxiosError>({
    queryKey: [QueryKeys.JOBS, id],
    queryFn: () => getJobDetails(id),
    enabled: !!id,
  });

  return query;
};